import React, { useEffect, useState } from 'react';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { DialogBoxComponent } from '../../components/DialogBox/DialogBoxCard';
import WarningIcon from '@mui/icons-material/Warning';
import TimeLine from '../Timesheets/SideDrawer/TimeLine';
import './NormalizationSideDrawer.css';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
  getRawTimings,
  removeFlagConsolidatedTimings,
} from '../../services/TimingService';
import { useDispatch, useSelector } from 'react-redux';
import {
  SHOW_NOTIFICATION,
  SNACKBAR_NODATA_MSG,
  TimeLineLoaderAttribute,
  HeaderLoaderAttribute,
  WARNING_KEY,
} from '../../constants';
import moment from 'moment';
import KeycloakService from '../../services/KeycloakService';
import Header from '../Timesheets/SideDrawer/Header';
import GenericLoader from '../../components/Loader/GenericLoader';
import {
  Box,
  Modal,
  Button,
  Typography,
  BottomNavigation,
} from '@mui/material';
import NewTimeLogAddition from './NewTimelogAddition';
import { deleteLogTime } from '../../services/TimingService';

const buttonStyle = {
  margin: '3%',
  color: 'white',
  backgroundColor: '#4d6cd9',
  width: '5%',
  height: '10%',
  '&:hover': {
    backgroundColor: '#5f7ada',
  },
  position: 'fixed',
  bottom: '3px',
  right: 0,
  marginTop: '6rem',
  float: 'right',
  marginRight: '2rem',
};
const buttonStyle2 = {
  margin: '3%',
  color: 'white',
  backgroundColor: '#4d6cd9',
  width: '15%',
  height: '40%',
  '&:hover': {
    backgroundColor: '#5f7ada',
  },
  position: 'relative',
  bottom: '3px',
  left: 0,
  marginTop: '6rem',
  float: 'left',
  marginleft: '2rem',
};
const boxStyle = {
  width: '30rem',
  backgroundColor: 'white',
  margin: 'auto',
  alignItems: 'center',
  marginTop: '10%',
  marginBottom: '100rem',
};

const modalButtonStyle = {
  margin: '7%',
  color: 'white',
  width: '5%',
  height: '19%',
};

const modalButtonStyleHover = {
  ...modalButtonStyle,
  '&:hover': {
    backgroundColor: '#5f7ada',
  },
};

const modalButtonStyleDelete = {
  ...modalButtonStyle,
  backgroundColor: 'red',
  '&:hover': {
    backgroundColor: '#ff4d4d',
  },
};
const modalButtonStyleYes = {
  ...modalButtonStyle,
  backgroundColor: '#4d6cd9',
  '&:hover': {
    backgroundColor: '#5f7ada',
  },
};

const modalButtonStyleNo = {
  ...modalButtonStyle,
  backgroundColor: 'red',
  '&:hover': {
    backgroundColor: '#ff4d4d',
  },
};

const NormalizationSideDrawer = (props) => {
  console.log(props);
  const { setIsEdit, handleDateChange } = props;
  const [showError, setShowError] = useState(false);
  const [slotDate, setSlotDate] = useState(new Date(props.selectedDate));
  const people = useSelector((state) => state.peopleState);
  const [rawTimeData, setRawTimingData] = useState([]);
  const [constantDate, setConstantDate] = useState(
    new Date(props.constantDate),
  );
  const [inTime, setInTime] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [dataIdClicked, setDataIdClicked] = useState(0);
  const [retrieve, setRetrieve] = useState();
  const [outTime, setOutTime] = useState('');
  const [open, setOpen] = useState(false);

  const [timelineloader, setTimelineLoader] = React.useState(true);
  const dispatch = useDispatch();
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const [headerLoader, setHeaderLoader] = React.useState(
    props.consolidatedPieData ? false : true,
  );

  useEffect(() => {
    rawTimings();
  }, [slotDate]);

  const rawTimings = async () => {
    const rawTimingsResponse = await getRawTimings(
      (people.id = props.employeeId),
      moment(slotDate).format('YYYY-MM-DD'),
    );

    if (rawTimingsResponse.isError === false) {
      console.log('rawTimingsResponse: ', rawTimingsResponse);
      setStatesFunction(rawTimingsResponse);
    }
    dipatchNotification(rawTimingsResponse.type, rawTimingsResponse.message);
  };
  const deleteLogTiming = async () => {
    setShowModal1(false);
    const deleteLogTimeResponse = await deleteLogTime(dataIdClicked);
    if (deleteLogTimeResponse.status == 200) {
      rawTimings();
    }
    dipatchNotification(
      deleteLogTimeResponse.type,
      deleteLogTimeResponse.message,
    );
    setIsEdit(true);
  };
  const setStatesFunction = (rawTimingsResponse) => {
    setRawTimingData((data) => [...rawTimingsResponse.data]);
    for (let i = 0; i < rawTimingsResponse.data.length; i++) {
      if (
        !rawTimingsResponse.data[i].isArchived &&
        rawTimingsResponse.data[i].direction.toLowerCase() === 'in'
      ) {
        setInTime(rawTimingsResponse.data[i].logTime.slice(0, 5));

        break;
      }
    }
    for (let i = rawTimingsResponse.data.length - 1; i >= 0; i--) {
      if (
        !rawTimingsResponse.data[i].isArchived &&
        rawTimingsResponse.data[i].direction.toLowerCase() === 'out'
      ) {
        setOutTime(rawTimingsResponse.data[i].logTime.slice(0, 5));
        break;
      }
    }
    !rawTimingsResponse
      ? dipatchNotification(WARNING_KEY, SNACKBAR_NODATA_MSG)
      : setTimelineLoader(false);
  };
  let id = 0;
  let archieveState = false;
  const TimeLineItemThings = (id, archieveState) => {
    setShowModal1(true);
    setDataIdClicked(id);
    setRetrieve(archieveState);
  };
  const prevDate = new Date(
    slotDate.getFullYear(),
    slotDate.getMonth(),
    slotDate.getDate() - 1,
  );
  const nextDate = new Date(
    slotDate.getFullYear(),
    slotDate.getMonth(),
    slotDate.getDate() + 1,
  );
  const handleCancel = () => {
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    try {
      await removeFlagConsolidatedTimings(
        props.constantDate,
        props.employeeId,
        props.flag,
      );
      setOpen(false);
      setIsEdit(true);
    } catch (error) {
      console.error('Failed to remove flag', error);
      dipatchNotification('error', 'Failed to remove flag');
    }
  };

  //  const constPrevDate = new Date(constantDate.getFullYear(), constantDate.getMonth(), constantDate.getDate()-1);
  //  const constNextDate = new Date(constantDate.getFullYear(), constantDate.getMonth(), constantDate.getDate()+1);

  return (
    <>
      <SwipeableDrawer
        className="drawer-width"
        anchor={'right'}
        open={props.drawerOpenFlag}
        onClose={props.closeDrawer('right', false)}
        onOpen={props.closeDrawer('right', true)}
      >
        {headerLoader ? (
          <Box className="div-header">
            <GenericLoader
              rectAttributes={HeaderLoaderAttribute}
              width={430}
              height={50}
              showError={showError}
              setShowError={setShowError}
              className="all-div-width"
            />
          </Box>
        ) : (
          <Box className="div-header">
            <Button
              sx={{
                width: '50px',
                minWidth: '0px',
                padding: '0px',
                mr: '5px',
                fontSize: '1.5rem',
              }}
              onClick={() => {
                handleDateChange(-1);
                setSlotDate(prevDate);
              }}
              // disabled={
              //   slotDate.toDateString() === constPrevDate.toDateString()
              // }
            >
              <KeyboardArrowLeftIcon />
            </Button>

            <Header
              date={props.selectedDate}
              inTime={inTime}
              outTime={outTime}
            />

            <Button
              sx={{
                width: '50px',
                minWidth: '0px',
                padding: '0px',
                ml: '5px',
                fontSize: '1.5rem',
              }}
              onClick={() => {
                handleDateChange(1);
                setSlotDate(nextDate);
              }}
              // disabled={
              //   slotDate.toDateString() === constNextDate.toDateString()
              // }
            >
              <KeyboardArrowRightIcon />
            </Button>
          </Box>
        )}

        {timelineloader ? (
          <Box>
            <GenericLoader
              rectAttributes={TimeLineLoaderAttribute}
              height={200}
              width={400}
              className="all-div-width"
            />
          </Box>
        ) : rawTimeData.length > 0 ? (
          <TimeLine
            TimeLineItemThings={TimeLineItemThings}
            rawTimings={rawTimings}
            employeeId={props.employeeId}
            selectedDate={props.selectedDate}
            rawTimeData={rawTimeData}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100px',
            }}
          >
            No Raw Timing Data
          </div>
        )}
        <Box>
          <Button style={buttonStyle} onClick={() => setShowModal(true)}>
            Add Timing
          </Button>
        </Box>
        {props.flag === 'TIME_LIMIT_EXCEEDED' && (
          <Box>
            <Button style={buttonStyle2} onClick={() => setOpen(true)}>
              Remove flag
            </Button>
          </Box>
        )}

        <Modal open={showModal} onClose={() => setShowModal(false)}>
          <Box style={boxStyle}>
            <NewTimeLogAddition
              setIsEdit={setIsEdit}
              rawTimings={rawTimings}
              setShowModal={setShowModal}
              employeeId={props.employeeId}
              selectedDate={props.selectedDate}
              rawTimeData={rawTimeData}
            />
          </Box>
        </Modal>

        <Modal open={showModal1} onClose={() => setShowModal1(false)}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <Box
              style={{
                ...boxStyle,
                width: '28%',
                textAlign: 'center',
                height: '12rem',
                backgroundColor: 'white',
                position: 'absolute',
                top: '20%',
                left: '30%',
              }}
            >
              <Typography sx={{ paddingTop: ' 10%' }}>
                {retrieve
                  ? 'Do you want to retrieve this timelog?'
                  : 'Do you want to delete this timelog?'}
              </Typography>

              <Button
                style={modalButtonStyleNo}
                onClick={() => setShowModal1(false)}
              >
                No
              </Button>
              <Button
                style={modalButtonStyleYes}
                onClick={() => deleteLogTiming()}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </Modal>
      </SwipeableDrawer>
      <DialogBoxComponent
        open={open}
        handleClose={handleClose}
        confirmText="Yes"
        cancelText="No"
        content={`Are you sure, you want to remove the flag?`}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        icon={<WarningIcon color="warning" />}
      />
    </>
  );
};

export default NormalizationSideDrawer;
